import React from 'react';
import { Reveal } from './Reveal';
import { leadReason, supportingReasons } from '../data/content';
export function WhyGrowth() {
  return <section id="razones" className="border-b border-white/10" aria-labelledby="why-title" data-id="element-139" data-mp="3vuctw1ynevnw">
      <div className="mx-auto max-w-6xl px-6 py-24 lg:py-28" data-id="element-140" data-mp="3o7n05rgwerj">
        <Reveal className="max-w-3xl" data-id="element-141" data-mp="8hu1m3h6yspz">
          <p className="text-sm text-zinc-500" data-id="element-142" data-mp="8ivdub9y1l9a">Autoridad</p>
          <h2 id="why-title" className="mt-5 text-3xl font-semibold leading-[1.1] tracking-[-0.02em] text-white sm:text-4xl" data-id="element-143" data-mp="dfbz8xprdlio">
            Por qué sí vamos a crecer tu negocio.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-zinc-400" data-id="element-144" data-mp="nc6xrgm17lwy">
            No por optimismo ni porque «probemos cosas nuevas». Por cuatro
            razones estructurales que se pueden verificar antes de firmar nada.
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mt-16" data-id="element-145" data-mp="2t6htperio3l4">
          <article className="border border-white/10 bg-ink-900 p-8 lg:p-12" data-id="element-146" data-mp="2t9ce56aj5oej">
            <p className="font-mono text-xs uppercase tracking-[0.16em] text-accent" data-id="element-147" data-mp="etile3ntxdnb">
              Razón principal
            </p>
            <h3 className="mt-6 max-w-2xl text-2xl font-semibold leading-snug tracking-[-0.01em] text-white lg:text-3xl" data-id="element-148" data-mp="525pn0ywu3c0">
              {leadReason.title}
            </h3>
            <p className="mt-6 max-w-3xl text-base leading-relaxed text-zinc-300" data-id="element-149" data-mp="4w2xt2wo5rv">
              {leadReason.body}
            </p>
            <p className="mt-8 max-w-3xl border-t border-white/10 pt-6 font-mono text-sm text-accent" data-id="element-150" data-mp="srqkah4fep14">
              {leadReason.proof}
            </p>
          </article>
        </Reveal>

        <div className="mt-px grid gap-px border border-t-0 border-white/10 bg-white/10 lg:grid-cols-3" data-id="element-151" data-mp="nugqkpa07r7h">
          {supportingReasons.map((reason, i) => <div key={reason.title} className="flex bg-ink-950" data-id="element-152" data-mp="38jnvj2v4h09s" data-mpi={i}>
              <Reveal delay={i * 0.05} className="flex w-full" data-id="element-153" data-mp="33j9zykapjisn">
                <div className="flex h-full w-full flex-col p-8" data-id="element-154" data-mp="33lw7ijxllyav">
                  <h3 className="min-h-[3.5rem] text-lg font-semibold leading-snug text-white" data-id="element-155" data-mp="1vlno9vyht0vc">
                    {reason.title}
                  </h3>
                  <p className="mt-4 text-sm leading-relaxed text-zinc-400" data-id="element-156" data-mp="1lmezrimecegd">
                    {reason.body}
                  </p>
                  <p className="mt-auto pt-6 font-mono text-xs text-zinc-500" data-id="element-157" data-mp="1qk6s2dqye2l3">
                    {reason.proof}
                  </p>
                </div>
              </Reveal>
            </div>)}
        </div>
      </div>
    </section>;
}